import CountUp from "react-countup";
import styled from "styled-components";
import { FaGraduationCap, FaChartLine, FaUsers } from "react-icons/fa";

const SectionFranceInvestment = styled.section`
    background: linear-gradient(90deg, #e8f5e9, #c8e6c9);
    padding: 60px 40px;
    color: #1b5e20;
`;

const TitreFranceInvestment = styled.h2`
    text-align: center;
    font-size: 40px;
    margin-bottom: 60px;
    color: #388e3c;
    font-weight: bold;
`;

const ConteneurGrilleFranceInvestment = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
`;

const BoiteFranceInvestment = styled.div`
    background: #dcedc8;
    padding: 50px 40px;
    border-radius: 20px;
    text-align: center;
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);
    transition: transform 0.4s ease, box-shadow 0.4s ease;

    &:hover {
        transform: translateY(-12px);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
    }
`;

const ConteneurIcôneFranceInvestment = styled.div`
    font-size: 48px;
    margin-bottom: 20px;
    color: #388e3c;
`;

const TexteNombreFranceInvestment = styled.div`
    font-size: 36px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #388e3c;
`;

const DescriptionFranceInvestment = styled.div`
    font-size: 22px;
    color: #1b5e20;
`;

const PourquoiFranceInvestment = () => {
  return (
    <SectionFranceInvestment>
      <TitreFranceInvestment>Qu'est-ce qui fait la force de France Investment ?</TitreFranceInvestment>
      <ConteneurGrilleFranceInvestment>
        <BoiteFranceInvestment>
          <ConteneurIcôneFranceInvestment>
            <FaGraduationCap />
          </ConteneurIcôneFranceInvestment>
          <TexteNombreFranceInvestment>
            <CountUp end={12345} duration={3} separator="," />
          </TexteNombreFranceInvestment>
          <DescriptionFranceInvestment>Éducations Financières</DescriptionFranceInvestment>
        </BoiteFranceInvestment>
        <BoiteFranceInvestment>
          <ConteneurIcôneFranceInvestment>
            <FaChartLine />
          </ConteneurIcôneFranceInvestment>
          <TexteNombreFranceInvestment>
            <CountUp end={87} duration={3} separator="," />
          </TexteNombreFranceInvestment>
          <DescriptionFranceInvestment>Stratégies d'Investissement</DescriptionFranceInvestment>
        </BoiteFranceInvestment>
        <BoiteFranceInvestment>
          <ConteneurIcôneFranceInvestment>
            <FaUsers />
          </ConteneurIcôneFranceInvestment>
          <TexteNombreFranceInvestment>
            <CountUp end={5432} duration={3} separator="," />
          </TexteNombreFranceInvestment>
          <DescriptionFranceInvestment>Membres de la Communauté</DescriptionFranceInvestment>
        </BoiteFranceInvestment>
      </ConteneurGrilleFranceInvestment>
    </SectionFranceInvestment>
  );
};
export default PourquoiFranceInvestment;